// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Util from "../../common/util.bs.js";
import * as BsCss from "../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as StaticImage from "../StaticImage.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import ReactCopyToClipboard from "react-copy-to-clipboard";

var button = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.pct(100.0)),
      tl: {
        hd: BsCss.media("(min-width: 480px)", {
              hd: BsCss.width(BsCss.rem(20.0)),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

var copyImg = Curry._1(BsCss.style, {
      hd: BsCss.important(BsCss.width(BsCss.px(35))),
      tl: /* [] */0
    });

var Styles = {
  button: button,
  copyImg: copyImg
};

function ResponsiveClipboard(props) {
  var orderNumber = props.orderNumber;
  var match = React.useState(function () {
        return false;
      });
  var setIsCopied = match[1];
  var isCopied = match[0];
  var id = {
    contents: setTimeout((function (param) {
            
          }), 0)
  };
  React.useEffect((function () {
          if (isCopied) {
            id.contents = setTimeout((function (param) {
                    Curry._1(setIsCopied, (function (param) {
                            return false;
                          }));
                  }), 1500);
          }
          
        }), [isCopied]);
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(JsxRuntime.jsx(ReactCopyToClipboard, {
                        children: JsxRuntime.jsxs("button", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("p", {
                                              children: Util.ReactStuff.s("Your order number"),
                                              className: "text-xs text-gray-500"
                                            }),
                                        isCopied ? JsxRuntime.jsx("p", {
                                                children: Util.ReactStuff.s("Order copied"),
                                                className: "text-xs"
                                              }) : JsxRuntime.jsx("p", {
                                                children: Util.ReactStuff.s(orderNumber),
                                                className: "text-xs"
                                              })
                                      ]
                                    }),
                                isCopied ? JsxRuntime.jsx(StaticImage.make, {
                                        src: "/images/success.svg",
                                        alt: "copy",
                                        width: 35,
                                        height: 35,
                                        className: "w-8 h-8 p-1"
                                      }) : JsxRuntime.jsx(StaticImage.make, {
                                        src: "/images/copy_button.svg",
                                        alt: "copy",
                                        width: 24,
                                        height: 24,
                                        className: copyImg
                                      })
                              ],
                              className: Cn.make([
                                    "mx-auto flex items-center justify-between border shadow-md px-2 py-1 rounded-md box-shadow my-2 cursor-pointer text-left outline-none hover:bg-white-smoke",
                                    button
                                  ]),
                              onClick: (function (param) {
                                  Curry._1(setIsCopied, (function (param) {
                                          return true;
                                        }));
                                })
                            }),
                        text: orderNumber
                      }))
            });
}

var make = ResponsiveClipboard;

export {
  Styles ,
  make ,
}
/* button Not a pure module */
